var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.downloading)?_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-diameter":25,"md-stroke":2}}):_c('md-button',{on:{"click":_vm.doDownload}},[_vm._v("Download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }